<template xmlns="http://www.w3.org/1999/html">
    <form role="form">
        <!-- Customer Create Window -->
        <window-create-customer
            :visible="windowCreateCustomerWindowVisible"
            ref="createCustomerWindow"
            @customer-created="onCustomerCreated"
            @closed="onWindowClosed"
        ></window-create-customer>



        <ValidationObserver v-slot="{ invalid }">

            <div class="form-group row">
                <label class="col-md-4 offset-md-4 descriptionPaddingTop">
                    <div class="card">
                        <div class="card-body ">
                            <p class="card-text" v-html="$t('requestpage.info')">
                            </p>
                        </div>
                    </div>
                </label>
            </div>


            <!--
            <div class="form-group row" style="padding-bottom:25px;">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-7">
                    <request-previous
                    ></request-previous>
                </div>
            </div>
            -->

            <!--
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">E-Mail</label>
                <div class="col-md-6">
                    <input placeholder="Ihre E-Mail Adresse" type="email" class="form-control" name="desc" v-model="form.email" @input="onEmailFieldChange">
                </div>
            </div>
            -->

            <ValidationProvider rules="required|email" v-slot="{ valid, errors }">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.email') }}</label>
                    <div class="col-md-6">
                            <input :placeholder="$t('requestpage.email-placeholder')" type="email" class="form-control" name="email" v-model="form.email" @input="onEmailFieldChange">
                            <span class="form-errors">{{ errors[0] }}</span>
                    </div>
                </div>
                <div class="form-group row" v-if="customerNotFound && valid" >
                    <div class="col-md-6 offset-md-4">
                        <div class="p-3 mb-2 text-dark alert alert-warning" role="alert">
                            <p>{{ $t('requestpage.contact-not-found')}}</p>
                            <span v-if="!formdisabled" title="Neu anlegen" class="k-button" style="width: 10%; height: auto" @click="showCreateCustomerWindow">&nbsp;<i class="far fa-user-plus"></i>&nbsp;{{ $t('requestpage.contect-create-new') }}</span>
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="customerFound && valid">
                    <div class="col-md-6 offset-md-4">
                        <div class="p-3 mb-2 bg-success text-light alert alert-info" role="alert">
                            {{ $t('requestpage.contect-found') }}
                        </div>
                    </div>
                </div>
            </ValidationProvider>


            <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.description') }}</label>
                    <div class="col-md-6">
                        <input :disabled="formdisabled" :placeholder="$t('requestpage.description-placeholder')" type="text" class="form-control" name="desc" v-model="form.desc">
                        <span class="form-errors">{{ errors[0] }}</span>
                    </div>
                </div>
            </ValidationProvider>

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.desired-period') }}</label>
                <div class="col-md-6">
                    <date-picker
                        @apply="onDateChange"
                        @loaded="onDatePickerLoaded"
                        :mode="'request'"
                        :presetTimes="getPresetTimes"
                        :disabled="formdisabled"
                    ></date-picker>
                </div>
            </div>

            <hr>

            <div class="form-group row">
                <h5 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.check-out') }}</h5>
            </div>

            <!-- Art der Herausgabe -->
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.check-out-type') }}</label>
                <div class="col-md-6">
                    <kendo-dropdownlist ref="pickupMethodDropdown"
                                        style="width:300px"
                                        v-model="form.delivery_method_id"
                                        :data-items="pickupMethodDatasource"
                                        :text-field="'name'"
                                        :value-field="'id'"
                                        :data-item-key="'id'"
                                        :value-primitive="true"
                                        :default-item="placeholders.general_please_choose"
                                        :disabled="formdisabled"
                    >
                    </kendo-dropdownlist>
                </div>
            </div>

            <!-- Herausgabeort -->
            <div v-if="form.delivery_method_id == 1" key="pickupPlaceKey">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.check-out-location') }}</label>
                    <div class="col-md-6">
                        <kendo-dropdownlist
                            style="width:300px"
                            ref="tagboxPickupPlace"
                            v-model="form.delivery_location"
                            :data-items="tagPickupRetPlaceDatasource"
                            :text-field="'text'"
                            :value-field="'id'"
                            :data-item-key="'id'"
                            :value-primitive="true"
                            :default-item="placeholders.tagPickup"
                            :disabled="formdisabled"
                        >
                        </kendo-dropdownlist>
                    </div>
                </div>
            </div>

            <div v-if="form.delivery_method_id==2 || form.delivery_method_id==3 || form.delivery_method_id==4" key="deliveryMethodAddress">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.shipping-to') }}</label>
                    <div class="col-md-6">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="self" v-model="form.delivery_target_type">
                            <label class="form-check-label" for="inlineRadio1">{{ $t('requestpage.ship-to-address-of-recipient') }}</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="other" v-model="form.delivery_target_type">
                            <label class="form-check-label" for="inlineRadio2">{{ $t('requestpage.ship-to-different-address') }}</label>
                        </div>
                    </div>
                </div>

                <!-- Adresse des Mietempfängers -->
                <div v-if="form.delivery_target_type == 'self' && customerData != 0" key="deliveryTargetTypeShowAddress">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-2">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">{{ customerData['first_name'] }} {{ customerData['last_name'] }}</h5>
                                    <div class="card-text">
                                        {{ customerData['company'] }}<br>
                                        {{ customerData['address'] }}<br>
                                        {{ customerData['city'] }} {{ customerData['zip'] }}<br>
                                        {{ customerData['country'] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Abweichende Adresse -->
                <div v-if="form.delivery_target_type == 'other'" key="deliveryTargetTypeOther">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-2">
                            <label for="delivery_target_type_other_name">{{ $t('address.first-name') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_name" placeholder="" v-model="form.delivery_target_type_other['name']">
                        </div>
                        <div class="col-md-2">
                            <label for="delivery_target_type_other_surname">{{ $t('address.name') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_surname" placeholder="" v-model="form.delivery_target_type_other['surname']">
                        </div>
                        <div class="col-md-2">
                            <label for="delivery_target_type_other_company">{{ $t('address.company') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_company" placeholder="" v-model="form.delivery_target_type_other['company']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-4">
                            <label for="delivery_target_type_other_street">{{ $t('address.street') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_street" :placeholder="$t('address.street-placeholder')" v-model="form.delivery_target_type_other['address']">
                        </div>
                        <div class="col-md-2">
                            <label for="delivery_target_type_other_additional">{{ $t('address.note') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.delivery_target_type_other['additional']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-1">
                            <label for="delivery_target_type_other_zip">{{ $t('address.zip') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_zip" v-model="form.delivery_target_type_other['zip']">
                        </div>
                        <div class="col-md-3">
                            <label for="delivery_target_type_other_city">{{ $t('address.city') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_city" v-model="form.delivery_target_type_other['city']">
                        </div>
                        <div class="col-md-2">
                            <label for="delivery_target_type_other_country">{{ $t('address.country') }}</label>
                            <input type="text" class="form-control" id="delivery_target_type_other_country" v-model="form.delivery_target_type_other['country']">
                        </div>
                    </div>
                </div>
            </div>


            <div class="form-group row">
                <h5 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.check-in') }}</h5>
            </div>



            <!-- Art der Rückgabe -->
            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.check-in-type') }}</label>
                <div class="col-md-6">
                    <kendo-dropdownlist ref="deliveryMethodDropdown"
                                        style="width:300px"
                                        v-model="form.return_method_id"
                                        :data-items="returnMethodDatasource"
                                        :text-field="'name'"
                                        :value-field="'id'"
                                        :data-item-key="'id'"
                                        :value-primitive="true"
                                        :default-item="placeholders.general_please_choose"
                                        :disabled="formdisabled"
                    >
                    </kendo-dropdownlist>
                </div>
            </div>

            <!-- Rückgabeort -->
            <div v-if="form.return_method_id == 1" key="returnPlaceKey">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.check-in-location') }}</label>
                    <div class="col-md-6">
                        <kendo-dropdownlist
                            style="width:300px"
                            ref="tagboxRetPlace"
                            v-model="form.ret_location"
                            :data-items="tagPickupRetPlaceDatasource"
                            :text-field="'text'"
                            :value-field="'id'"
                            :data-item-key="'id'"
                            :value-primitive="true"
                            :default-item="placeholders.tagReturn"
                        >
                        </kendo-dropdownlist>
                    </div>
                </div>
            </div>

            <!-- Rücksendung durch Mietempfänger -->
            <div v-if="form.return_method_id==2" key="returnByReceiverTypes">

                <!-- Rücksendung an: Zurück zum Absender / Abweichende Addresse -->
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.return-to') }}</label>
                    <div class="col-md-6">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionReturnToSender" value="returnToSender" v-model="form.return_by_receiver_target_type">
                            <label class="form-check-label" for="returnTargetTypeOptionReturnToSender">{{ $t('requestpage.return-to-sender') }}</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionReturnToSenderOther" value="other" v-model="form.return_by_receiver_target_type">
                            <label class="form-check-label" for="returnTargetTypeOptionReturnToSenderOther">{{ $t('requestpage.return-to-different-address') }}</label>
                        </div>
                    </div>
                </div>

                <!-- Rücksendung durch Mietempfänger : Abweichende Addresse-->
                <div v-if="form.return_by_receiver_target_type == 'other'" key="returnByReceiverTargetTypeOther">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-2">
                            <label for="return_by_receiver_target_type_other_name">{{ $t('address.first-name') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_name" placeholder="" v-model="form.return_by_receiver_target_type_other['name']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_by_receiver_target_type_other_surname">{{ $t('address.name') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_surname" placeholder="" v-model="form.return_by_receiver_target_type_other['surname']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_by_receiver_target_type_other_company">{{ $t('address.company') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_company" placeholder="" v-model="form.return_by_receiver_target_type_other['company']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-4">
                            <label for="return_by_receiver_target_type_other_street">{{ $t('address.street') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_street" :placeholder="$t('address.street-placeholder')" v-model="form.return_by_receiver_target_type_other['address']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_by_receiver_target_type_other_additional">{{ $t('address.note') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.return_by_receiver_target_type_other['additional']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-1">
                            <label for="return_by_receiver_target_type_other_zip">{{ $t('address.zip') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_zip" v-model="form.return_by_receiver_target_type_other['zip']">
                        </div>
                        <div class="col-md-3">
                            <label for="return_by_receiver_target_type_other_city">{{ $t('address.city') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_city" v-model="form.return_by_receiver_target_type_other['city']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_by_receiver_target_type_other_country">{{ $t('address.country') }}</label>
                            <input type="text" class="form-control" id="return_by_receiver_target_type_other_country" v-model="form.return_by_receiver_target_type_other['country']">
                        </div>
                    </div>
                </div>

            </div>

            <!-- Abholung / Rücksendung durch Bosch eBike oder Evolan-->
            <div v-if="form.return_method_id==3 || form.return_method_id==4 || form.return_method_id==5 || form.return_method_id==6 || form.return_method_id==7" key="returnMethodAddress">

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.pickup-return-from') }}</label>
                    <div class="col-md-6">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionSelf" value="self" v-model="form.return_target_type">
                            <label class="form-check-label" for="returnTargetTypeOptionSelf">{{ $t('requestpage.pickup-return-from-address-of-recipient') }}</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="returnTargetTypeOptions" id="returnTargetTypeOptionOther" value="other" v-model="form.return_target_type">
                            <label class="form-check-label" for="returnTargetTypeOptionOther">{{ $t('requestpage.pickup-return-from-different-address') }}</label>
                        </div>
                    </div>
                </div>

                <!-- Adresse des Mietempfängers -->
                <div v-if="form.return_target_type == 'self' && customerData != 0" key="deliveryTargetTypeShowAddress">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-2">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">{{ customerData['first_name'] }} {{ customerData['last_name'] }}</h5>
                                    <div class="card-text">
                                        {{ customerData['company'] }}<br>
                                        {{ customerData['address'] }}<br>
                                        {{ customerData['city'] }} {{ customerData['zip'] }}<br>
                                        {{ customerData['country'] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="form.return_target_type == 'other'" key="returnTargetTypeOther">
                    <!-- Datenübernahme von "anderer Adresse" der Lieferung -->
                    <div class="form-group row" v-if="form.delivery_target_type == 'other'" key="returnTargetTypeOtherApplyFromDelivery">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>

                        <div class="col-md-2">
                            <a class="k-button form-control" @click="applyOtherReturnAddressFromOtherDeliveryAddress"><span class="k-icon k-i-copy"></span>&nbsp; {{ $t('requestpage.use-address-from-shipping') }}</a>
                        </div>
                        <div class="col-md-1">
                            <a class="k-button form-control" @click="resetOtherReturnAddress"><span class="k-icon k-i-reset"></span>&nbsp; {{ $t('general.clear_fields') }}</a>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-2">
                            <label for="return_target_type_other_name">{{ $t('address.first-name') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_name" placeholder="" v-model="form.return_target_type_other['name']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_target_type_other_surname">{{ $t('address.name') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_surname" placeholder="" v-model="form.return_target_type_other['surname']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_target_type_other_company">{{ $t('address.company') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_company" placeholder="" v-model="form.return_target_type_other['company']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-4">
                            <label for="return_target_type_other_street">{{ $t('address.street') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_street" :placeholder="$t('address.street-placeholder')" v-model="form.return_target_type_other['address']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_target_type_other_additional">{{ $t('address.note') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_additional" :placeholder="$t('address.note-placeholder')" v-model="form.return_target_type_other['additional']">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">&nbsp;</label>
                        <div class="col-md-1">
                            <label for="return_target_type_other_zip">{{ $t('address.zip') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_zip" v-model="form.return_target_type_other['zip']">
                        </div>
                        <div class="col-md-3">
                            <label for="return_target_type_other_city">{{ $t('address.city') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_city" v-model="form.return_target_type_other['city']">
                        </div>
                        <div class="col-md-2">
                            <label for="return_target_type_other_country">{{ $t('address.country') }}</label>
                            <input type="text" class="form-control" id="return_target_type_other_country" v-model="form.return_target_type_other['country']">
                        </div>
                    </div>
                </div>



                <!--
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">Abholadresse</label>
                    <div class="col-md-6">
                        <textarea :disabled="formdisabled" type="text" class="form-control" name="pickupAddress" v-model="form.pickupAddress" placeholder="Abholadresse"></textarea>
                    </div>
                </div>-->
            </div>

            <hr>
            <div class="form-group row">
                <h4 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.request-type') }}</h4>
            </div>


            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioRequestType" id="inlineRadioSpecific" value="specific" v-model="form.request_equipment_select_type">
                        <label class="form-check-label" for="inlineRadioSpecific">{{ $t('requestpage.equipment-direct') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioRequestType" id="inlineRadioFree" value="unspecific" v-model="form.request_equipment_select_type">
                        <label class="form-check-label" for="inlineRadioFree">{{ $t('requestpage.equipment-choose') }}</label>
                    </div>
                </div>
            </div>

          <!-- Beschreibung des Equipments -->
            <div class="form-group row" v-show="form.request_equipment_select_type =='unspecific'">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.equipment-description') }}</label>

                <div class="col-md-6" v-show="form.request_equipment_select_type =='unspecific'">
                    <textarea :disabled="formdisabled" type="text" rows=6 class="form-control" name="noteField" v-model="form.request_desc" :placeholder="$t('requestpage.equipment-description-placeholder')"></textarea>
                </div>
            </div>

          <!-- Spezifische Auswahl des Equipments -->
            <div class="form-group row" v-show="form.request_equipment_select_type =='specific'">
                <h5 class="col-md-4 text-md-right pt-2"></h5>
                <div class="col-md-7">
                    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                        </symbol>
                        <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                        </symbol>
                        <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                        </symbol>
                    </svg>
                  <!-- Hinweisbox über Kategorien -->
                    <div class="alert alert-warning d-flex align-items-top" role="alert">
                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Warning:"><use xlink:href="#exclamation-triangle-fill"/></svg>&nbsp;&nbsp;
                      <div>
                        <b>{{ $t('requestpage.category-note-1') }}</b><br>
                        {{ $t('requestpage.category-note-2') }}<br><br>
                      </div>
                    </div>
                </div>

              <div class="col-md-7 offset-md-4">
                  <table class="table table-sm thead-bg table-bordered">
                    <thead>
                    <tr>
                      <th scope="col">{{$t('category.name')}}</th>
                      <th scope="col">{{$t('category.description')}}</th>
                      <!--<th scope="col">{{$t('category.special')}}</th>-->
                      <th scope="col">{{$t('category.special-title')}}</th>
                      <th scope="col">{{$t('category.special-note')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--<tr v-for="category in categories" :key="category.id" :class="category.is_special ? 'table-warning' : 'table-default'">-->
                    <tr v-for="category in categories" :key="category.id">
                      <th scope="row">{{category.name}}</th>
                      <td >{{$t('cstrings.' + category.description)}}</td>
                      <!--<td >{{$t('general.' + category.is_special)}}</td>-->
                      <td >{{$t('cstrings.' + category.info_title)}}</td>
                      <td >{{$t('cstrings.' + category.info_message)}}</td>
                    </tr>
                    </tbody>
                  </table>
              </div>
            </div>
            <div class="form-group row" style="padding-bottom:25px;" v-show="form.request_equipment_select_type =='specific'">
                <label class="col-md-4 col-form-label text-md-right"></label>
                <div class="col-md-7">
                    <object-picker-br
                        ref="objectpicker"
                        @objectAdd="onObjectAdd"
                        @objectRemove="onObjectRemove"
                        :availabilityDates="form.dates"
                        :mode="mode"
                        :pickType="'request'"
                        :formdisabled="formdisabled"
                        :presetobjects="form.rmsObjects"
                        :presetobjectid="presetobjectid"
                    >
                    </object-picker-br>
                </div>
            </div>

            <div class="form-group row">
                <h4 class="col-md-4 text-md-right pt-2">{{ $t('requestpage.additional-info') }}</h4>
            </div>

            <div class="form-group row">
                <label class="col-md-4 col-form-label text-md-right">{{ $t('requestpage.additional-label') }}</label>

                <div class="col-md-6">
                    <textarea :disabled="formdisabled" type="text" class="form-control" name="noteField" v-model="form.request_note" :placeholder="$t('requestpage.additional-placeholder')"></textarea>
                </div>
            </div>


            <div class="form-group row mb-0">
                <div class="col-md-6 offset-md-4">
                    <button type="submit" class="btn btn-secondary" v-if="mode != 'display'"
                            @click.prevent="goBack">
                        {{ $t('buttons.back-abort') }}
                    </button>
                    <button :disabled="invalid" type="submit" class="btn btn-success" v-if="mode == 'create' || this.mode == 'create-duplicated' "
                            @click.prevent="createRequest">
                        {{$t('requestpage.submit-request')}}
                    </button>
                </div>
            </div>
        </ValidationObserver>
    </form>
</template>

<script>
    import { validate } from 'vee-validate';

    import tagNoDataTemplate from "../rmsobjects/tag-nodata-template";
    import ObjectPickerBr from "../orders/object-picker-br";
    import CustomerPicker from "../orders/customer-picker";

    export default {
        name: "form-request",
        components: {
            ObjectPickerBr
        },
        props: {
            user: [String, Number],
            presetobjectid: [Number, Boolean],
            presetcustomerid: [Number, Boolean],
            orderid: [Number, Boolean],
            presetdata:[Object, Boolean],
            formdisabled: Boolean,
            mode: {
                type: String,
                default: 'create'
            },
            context:[String]
        },
        data: function () {
            return {
                tagPickupRetPlaceDatasource: [],
                pickupMethodDatasource: [],
                returnMethodDatasource: [],


                windowCreateCustomerWindowVisible: false,

                loadedOrder: false,
                customerNotFound: false,
                customerFound: false,

                /**
                 * Erweitert die Kontaktdaten um ein kombiniertes Feld für die Anzeige von Kunden
                **/
                parseSchemaData: function(data){
                    $.each(data.data, function(idx, elem) {
                        elem.combined_value = elem.id + ' - ' +elem.first_name + ' ' + elem.last_name + ', ' + elem.company;
                    });
                    return data;
                },
                itemTemplate: '#= id # - #= first_name # #= last_name #, #= company #',
                schemaModelFields: {
                    id: { editable: false, nullable: true },
                    first_name: { validation: { required: true } },
                    last_name: { validation: { required: true } },
                    combined_value: { validation: { required: true } }
                },
                today: '',

                customerData: 0,
                responsibilityData: 0,
                categories: {},

                form:{
                    email: '',
                    desc: '',
                    request_desc: '',
                    request_equipment_select_type: 'specific',
                    delivery_method_id: null,
                    return_method_id: null,
                    request_note: '',
                    internal_use: false,
                    delivery_location: null,
                    delivery_target_type: 'self',
                    delivery_target_type_other: {},
                    ret_location: null,
                    return_target_type: 'self',
                    return_target_type_other: {},
                    return_by_receiver_target_type: 'returnToSender',
                    return_by_receiver_target_type_other: {},



                    requestNote: '',
                    from: new Date(),
                    until: new Date(),
                    dates:{
                        from: new Date(),
                        until: new Date()
                    },
                    rmsObjects: new Array(),
                    customerId: this.presetcustomerid
                },
                placeholders: {
                    general_please_choose: {
                        name: this.$t('general.please_choose')
                    },
                    tagPickup: {
                        text: this.$t('requestpage.check-out-location-placeholder')
                    },
                    tagReturn: {
                        text: this.$t('requestpage.check-in-location-placeholder')
                    }
                },
            }
        },
        computed:{
            getPresetTimes: function(){
                console.log("form-request: getPresetTimes", {from: this.form.dates.from, until: this.form.dates.until});
                return {from: this.form.dates.from, until: this.form.dates.until};
            },
        },
        mounted () {
            this.init();
        },
        methods: {
            // Übersetzt deutsche Texte im Namen der Datasource anhand cstrings-Tabelle
            translateDatasource: function(data){
                for (const dataKey in data) {
                    data[dataKey]['name'] = this.$t("cstrings." + data[dataKey]['name']);
                }
                return data;
            },

            init: function(){
                console.log("form-request init... ", this.orderid, this.mode, this.context);

                // Laden der Abhol und Rückgabe-Tags
                axios
                    .get('/api/orders/tagsPickupReturnPlace')
                    .then(response => {
                        this.tagPickupRetPlaceDatasource = response.data
                        console.log(response.data);
                    });

                // Laden der Liefermethoden
                axios
                    .get('/api/orders/deliveryMethods')
                    .then(response => {
                        this.pickupMethodDatasource = this.translateDatasource(response.data)
                    });


                // Laden der Rückgabemethoden
                axios
                    .get('/api/orders/returnMethods')
                    .then(response => {
                        this.returnMethodDatasource = this.translateDatasource(response.data)
                    });



                // Laden eines bestehenden Auftrags
                if(this.orderid){
                    console.log("loading existing request...");
                    /*
                    if(this.formdisabled){
                        this.mode = "display";
                    }else{
                        this.mode = "edit";
                    }*/

                    axios
                        .get('/api/orders/id/' + this.orderid)
                        .then(response => {
                            console.log("loaded request: ", response.data[0]);
                            this.loadedOrder = response.data[0];
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {})
                }else{
                    this.mode = "create";
                }

                // Alle Kategorien für Darstellung laden
              axios
                  .get('/api/rmsobjects/categories')
                  .then(response => {
                    this.categories = response.data;
                    console.log("Categorie::");
                    console.log(this.categories);
                  })
                  .catch(error => {
                    console.log("error loading categories", error);
                  })
                  .finally(() => {})

            },

            prepareData(){
                this.form.from = this.form.dates.from.format();
                this.form.until = this.form.dates.until.format();
            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function() {
                // Formulardaten setzen
                this.form = this.loadedOrder;
                this.$refs['tagbox'].kendoWidget().value(this.form.attachedTags);
                this.form.customerId = this.loadedOrder.customer.id;
                this.form.rmsObjects = this.loadedOrder.rmsobjects;
            },


            showCreateCustomerWindow: function(){
                this.windowCreateCustomerWindowVisible = true;
                let createCustomerWindow = this.$refs.createCustomerWindow;
                createCustomerWindow.setData({email: this.form.email});
                //createCustomerWindow.showWindow();
            },

            /**
             * Wird ausgelöst, wenn ein neuer Kunde angelegt wurde
             */
            onCustomerCreated: function(customerId, customer){
                console.log("Mietempfänger wurde angelegt", customerId, customer);

                // Jetzt muss erneut das Vorhandensein geprüft werden
                console.log("check again" + this.form.email);
                this.findCustomerByMail(this.form.email);

                /*let elem = this.$refs.customerDropdownList.kendoWidget();
                elem.dataSource.read();

                // Neu angelegten Kunden setzen
                this.setPreselectedCustomer(e);*/
            },

            onTagboxDataBound: function(e){
                console.log("tagbox-Databound");
            },

            /**
             * Setzt einmalig den Standardwert für die Tagbox für den Standort der Herausgabe des Auftrages
             **/
            onTagboxPickupPlaceDatabound: function(e){
                console.log("databoundpickup");
                if(this.mode == 'create'){
                    this.$refs['tagboxPickupPlace'].kendoWidget().value(1);
                }
            },

            /**
             * Setzt einmalig den Standardwert für die Tagbox für den Standort der Rückgabe des Auftrages
             **/
            onTagboxRetPlaceDatabound: function(e){
                console.log("databoundreturn");
                if(this.mode == 'create'){
                    this.$refs['tagboxRetPlace'].kendoWidget().value(1);
                }
            },

            /*
            onTagboxPickupPlaceChange: function(e){
                console.log("onTagboxPickupPlaceChange: ", e.sender.value());
                this.form.delivery_location = e.sender.value()[0];
            },

            onTagboxRetPlaceChange: function(e){
                console.log("onTagboxReturnPlaceChange: ", e.sender.value());
                this.form.ret_location = e.sender.value()[0];
            },*/

            applyOtherReturnAddressFromOtherDeliveryAddress: function(){
                // Kann nicht einfach zugewiesen werden, da sonst gleiche Referenz und Reactivity
                this.form.return_target_type_other = JSON.parse(JSON.stringify(this.form.delivery_target_type_other));
            },

            resetOtherReturnAddress: function(){
                this.form.return_target_type_other = {};
            },


            // region Tag-Box
            /**
             * Fügt durch Enter-Tastendruck einen neuen Tag hinzu
             * @param e
             */
            onTagboxKeyPress(e) {
                console.log(e);
                if (e.key !== "Enter") {
                    return;
                }
                e.preventDefault();

                let widget = this.$refs['tagbox'].kendoWidget();
                let newValue = widget.input.val();
                if(newValue.length > 0){
                    widget.dataSource.add({
                        text: newValue,
                        value: newValue
                    });

                    // Workaround für Kendo Bug
                    setTimeout(function(){
                        widget.value(widget.value().concat([newValue]));
                    }, 1);
                }
            },

            /**
             * Lädt das Template tag-nodata-template für die anzeige der Tagbox, wenn kein Tag gefunden werden kann
             * @param e
             * @returns {{template: {data, methods, name}, templateArgs: *}}
             */
            tagNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagbox'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },

            tagboxPickupPlaceNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagboxPickupPlace'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },

            tagboxRetPlaceNoDataTemplateLoader(e){
                e.text = 'footer';
                e.context = this;
                e.widget = this.$refs['tagboxRetPlace'].kendoWidget();
                return {
                    template: tagNoDataTemplate,
                    templateArgs: e
                }
            },

            onDatePickerLoaded: function (dates) {
                console.log("Picker loaded with dates", dates);
                this.form.dates = dates;
                this.form.from = dates.from;
                this.form.until = dates.until;
            },

            onDateChange: function (dates) {
                console.log("Buchungszeitraum geändert", dates);
                this.form.dates = dates;

                console.log("lade Verfügbarkeit der Verleihobjekte neu");
                this.$refs.objectpicker.reloadStore();

            },

            onCustomerChange: function (customerId) {
                console.log("Customer geändert", customerId);
                this.form.customerId = customerId;
            },

            onObjectAdd: function(addedObject) {
                this.form.rmsObjects.push(addedObject);
            },

            onObjectRemove: function(removedObject) {
                this.form.rmsObjects = this.form.rmsObjects.filter(function( obj ) {
                    return obj.id !== removedObject.id;
                });
            },

            onEmailFieldChange: _.debounce(function (e) {
                validate(this.form.email, 'required|email').then(result => {
                    if (result.valid) {
                        this.findCustomerByMail(this.form.email);
                    }
                });
            }, 500),

            findCustomerByMail: function(customerMail){
                // Kunde nach mail suchen
                axios
                    .get('/api/customers/email/' + this.form.email)
                    .then(response => {
                        console.log("customer by mail");
                        console.log(response);
                        this.customerNotFound = false;
                        this.customerFound = true;
                    })
                    .catch(error => {
                        console.log("err", error);
                        if(error.response.status == 404){
                         this.customerNotFound = true;
                         this.customerFound = false;
                        }
                    })
                    .finally(() => {})
            },



            /**
             * Öffnet dieses Fenster
             */
            showWindow(){
                this.today = new Date();
                //var window = this.$refs.createWindow.kendoWidget();
                //window.center().open();
            },

            /**
             * Schließt dieses Fenster
             */

            resetForm(){
                this.form = {};
            },

            onWindowActivated(){
                this.$refs.firstInput.focus();
            },

            onWindowClosed(){
                this.windowCreateCustomerWindowVisible = false;
            },


            /**
             * Sendet die Formulardaten zum Server und versucht den Auftrag anzulegen
             */
            createRequest() {
                this.prepareData();
                console.log(this.form);
                // Daten senden

                // Wenn eine User-ID vorhanden ist, dann an schnittstelle hinter auth guard senden, da benutzer bekannt.
                let postUrl = '/api/request'
                if(window.AshnetApp.userId){
                    postUrl = '/api/request-internal'
                }

                this.sendForm('post',postUrl, this.form)
                    .then(() => {
                        // Form leeren
                        console.log("Empty form here");
                        //this.resetForm();
                        this.$emit('object-created');
                    });
            },

            goBack(){
                if(this.context != ""){
                    this.handleBack(this.context, false, {reload: false, id: this.form.id});
                }else{
                    this.handleBack('requests-grid', false, {reload: false, id: this.form.id});
                }
            },

            sendForm(method, uri, form){

                return new Promise((resolve, reject) => {
                    axios[method](uri, JSON.parse(JSON.stringify(form)))
                        .then(response => {
                            console.log(response.data);
                            resolve(response.data);
                        })
                        .catch(errors => {
                            reject(errors.response.data);
                        });
                });
            },

            // region Tag-Box
            /**
             * Fügt durch Enter-Tastendruck einen neuen Tag hinzu
             * @param e
             */
            onTagboxKeyPress(e) {
                if (e.key !== "Enter") {
                    return;
                }
                e.preventDefault();

                let widget = this.$refs['tagbox'].kendoWidget();
                let newValue = widget.input.val();
                if(newValue.length > 0){
                    widget.dataSource.add({
                        text: newValue,
                        value: newValue
                    });

                    // Workaround für Kendo Bug
                    setTimeout(function(){
                        widget.value(widget.value().concat([newValue]));
                    }, 1);
                }
            },

            //endregion

        }
    }
</script>

<style scoped>
.objPicker{
    height:500px!important;
}
.descriptionPaddingTop{
    padding-top:40px;
}

/* Hintergrund für die Kategorien-Tabelle */
.thead-bg > thead > tr > th{
  background-color: #f3f4f5;
}

/* Textfarbe für die Kategorien-Tabelle */
.thead-bg{
  color: #616161;
}
</style>
